import * as styles from './buttonSet.module.css'

interface ButtonSetProps {
  alignment?: 'space-between' | 'center' | 'flex-end' | 'flex-start'
  children: React.ReactNode,
  className?: string,
}

const ButtonSet = ({ alignment = 'space-between', children, className = '' }: ButtonSetProps) =>
  <div
    className={`${styles.buttonSet} ${className ? className : ''}`}
    style={ alignment ? { justifyContent: alignment } : undefined}
  >
    { children }
  </div>

export default ButtonSet
